import { render, staticRenderFns } from "./MobileChat.vue?vue&type=template&id=69d723c1&scoped=true"
import script from "./MobileChat.vue?vue&type=script&lang=js"
export * from "./MobileChat.vue?vue&type=script&lang=js"
import style0 from "./MobileChat.vue?vue&type=style&index=0&id=69d723c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d723c1",
  null
  
)

export default component.exports